export default "__VITE_ASSET__4a3f16fa__"